module.exports = __webpack_public_path__ + "static/briashta_logo-2b5e7f7f357e797878ddc88b0a31f109.png";